var _circle, _circle2, _circle3, _circle4, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipse1070(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 46.349,
    cy: 46.349,
    r: 46.349,
    fill: "url(#paint0_radial_1232_1095)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 46.3995,
    cy: 46.3996,
    r: 39.6193,
    fill: "url(#paint1_radial_1232_1095)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 46.3996,
    cy: 46.3996,
    r: 32.2318,
    fill: "url(#paint2_radial_1232_1095)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.349,
    cy: 46.349,
    r: 24.0853,
    fill: "url(#paint3_radial_1232_1095)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7352 56.8726L43.9566 49.1898H36.4315L37.1012 45.0923H44.587L45.7689 37.646H49.9846L48.8026 45.0923H56.3278L55.658 49.1898H48.1723L46.9509 56.8726H42.7352Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1232_1095",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.2702 46.349) rotate(-121.212) scale(46.2237 45.4644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2CD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#6240FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6240FF",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1232_1095",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3321 46.3996) rotate(-121.212) scale(39.5121 38.8632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2CD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#6240FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6240FF",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1232_1095",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3448 46.3996) rotate(-121.212) scale(32.1446 31.6166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2CD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#6240FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6240FF",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1232_1095",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3081 46.349) rotate(-121.212) scale(24.0202 23.6256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2CD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#6240FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9078FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse1070);
export default __webpack_public_path__ + "static/media/Ellipse-1070.981d9ebbbdd7b13b792a9d5950780056.svg";
export { ForwardRef as ReactComponent };